// extracted by mini-css-extract-plugin
module.exports = {"content":"series-rss-content_content__2OruR"};